// @flow

import _ from 'lodash';
import ApiObject from '../ApiObject';

import ArrayUtils from '../../utils/ArrayUtils';

import UserAddress from './UserAddress';

export default class UserAddressessList extends ApiObject {

  addresses: Array<UserAddress> = [];

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data);

    // -- deserialize checks
    this.addresses = [];

    // -- handle the case were the api responds a json with the array directly.
    let dataAddresses = [];
    if (!_.isUndefined(data.addresses)) {
      dataAddresses = data.addresses;
    } else {
      dataAddresses = data;
    }

    _.each(dataAddresses, (checkData: Object) => {
      const address: UserAddress = new UserAddress();
      address.fromJson(checkData);
      this.addresses.push(address);
    });
  }

  findById(idToFind: string): ?UserAddress {
    return ArrayUtils.find(this.addresses, { id: idToFind });
  }

  update(address: UserAddress) {
    this.addresses = ArrayUtils.updateObject(this.addresses, address, { id: address.id });
  }

  unshift(address: UserAddress) {
    this.addresses.unshift(address);
  }

  delete(address: UserAddress) {
    this.addresses = ArrayUtils.deleteObject(this.addresses, address, { id: address.id });
  }
}
